/**
 * @type {Array<{label: string, value: string, desc: string, class: string}>}
 */
export const envList = [
  {
    label: "开发",
    value: "development",
    desc: "Dev",
    class: "mc-test-env",
  },
  {
    label: "线下",
    value: "test",
    desc: "Test",
    class: "mc-test-env",
  },
  {
    label: "预发",
    value: "staging",
    desc: "Staging",
    class: "mc-st-env",
  },
  {
    label: "线上",
    value: "production",
    desc: "Prod",
    class: "mc-prod-env",
  },
];

/**
 * @type {Object.<string, Object.<string, string>>}
 */
export const urlList = {
  jiemo: {
    test: "https://manager.osg.test.sankuai.com",
    production: "https://opcenter-keemart.mykeeta.com",
  },
  rss: {
    test: "https://maicaipeisong.mall.test.sankuai.com",
    production: "https://courier-keemart.mykeeta.com",
  },
  vss: {
    test: "https://vss.osg.test.sankuai.com",
    production: "https://partner-keemart.mykeeta.com",
  },
  lps: {
    test: "https://pass.osg.test.sankuai.com",
    production: "https://logistics-keemart.mykeeta.com",
  },
};
